import React, { useEffect } from 'react';
import {
  Flex,
  Heading,
  Box,
  Button,
  Text,
  Input,
  InputGroup,
  InputLeftAddon,
  HStack,
  Grid,
  GridItem,
  Switch,
  Spinner,
  Skeleton,
  IconButton,
  RadioGroup,
  Stack,
  Radio,
  Textarea,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai';
import SidebarWithHeader from '../../../components/Admin/SidebarWithHeader';
import ManajemenPengetahuanController, {
  useManajemenPengetahuanContext,
} from '../../../controller/admin/manajemen_pengetahuan';
import BoxUploadFile from '../../../components/Admin/UploadFile/BoxUploadFile';
import Select, { StylesConfig } from 'react-select';
import CardItem from '../../../components/Admin/Pengetahuan/CardItem';
import YoutubeContext, {
  useYoutubeContext,
} from '../../../controller/youtube/index';
import KelolaKontenManajemenPelatihanController, {
  useKelolaKontenManajemenPelatihanContext,
} from '../../../controller/admin/manajemen_pelatihan/kelola_konten';
import Pagination from '../../../components/Pagination';
import EditorComponent from '../../../components/Admin/Editor';
import { useRole } from '../../../../hooks/useRole';
import { useToast } from '@chakra-ui/react';

/**
 * ManajemenPengetahuan is a component that allows users to manage knowledge items.
 * It provides a form to create new knowledge items and displays a list of existing items.
 * Uses TinyMCE editor for description.
 * @component
 * @returns {JSX.Element} JSX.Element
 * @author Bagas Prasetyadi
 */

const ManajemenPengetahuan = () => {
  const {
    setManajemenPengetahuanState,
    postData,
    fetchData,
    clearState,
    getListKategoriPengetahuan,
    getPelatihanRelevan,
    getPengetahuanUtama,
    getListPrasyaratMandiri,
    getListTipeMandiri,
    searchPengetahuan,
    filterByJenis,
    filterByKategori,
    filterByStatus,
    clearFilter,
  } = useManajemenPengetahuanContext();
  const state = useManajemenPengetahuanContext().state;
  const { getListVideo } = useYoutubeContext();
  const { listVideo } = useYoutubeContext().state;
  const { getPaketSoal } = useKelolaKontenManajemenPelatihanContext();

  const {
    publish,
    image,

    description,
    listData,
    loadingData,
    mode,
    title,
    organizer,
    kategoriPengetahuanId,
    listKategoriPengetahuan,
    loadingAction,
    youtubeVideoSelected,
    pagination,
    perPage,
    page,
    type,
    startDate,
    endDate,
    is_klinik_khusus,
    listKategoriKlinikKhusus,
    kategoriKlinikKhusus,
    pelatihanSelected,
    search_pelatihan,
    listPelatihan,
    listPengetahuanUtama,
    pengetahuanUtamaSelected,
    review_url,
    customSertifikat,
    keteranganSertifikat,
    jenisPersyaratan,
    tipe_klinik_khusus_mandiri,
    prasyarat_klinik_khusus_mandiri,
    listTipeMandiri,
    listPrasyaratMandiri,
    filterKeyword,
    filterJenisPengetahuan,
    filterKategoriId,
    filterStatusPublish,
  } = state;

  const toast = useToast();
  const { canMutate } = useRole();
  const loadingEdit = false;

  const statusOptions = [
    { label: 'Semua', value: '0,1' },
    { label: 'Published', value: '1' },
    { label: 'Draft', value: '0' },
  ];

  const jenisOptions = [
    { label: 'Asynchronized', value: 'asynchronized' },
    { label: 'Synchronized', value: 'synchronized' },
  ];

  const hasActiveFilter =
    !!filterKeyword ||
    !!filterJenisPengetahuan ||
    !!filterKategoriId ||
    filterStatusPublish !== '0,1';

  const totalPage = pagination ? Math.ceil(pagination.total_rows / perPage) : 0;

  const handlePageChange = (e) => {
    setManajemenPengetahuanState('page', e.selected + 1);
  };

  const colourStyles: StylesConfig<any, boolean> = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: '#F6F5F8',
        padding: '2px 8px',
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        zIndex: 100,
      };
    },
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color = '#38A169';

      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? color
          : isFocused
          ? '#C6F6D5'
          : undefined,
        color: isDisabled ? 'white' : isSelected ? 'white' : 'black',

        cursor: isDisabled ? 'not-allowed' : 'default',

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? 'white'
              : color
            : undefined,
          color: isDisabled ? 'white' : isSelected ? 'black' : 'white',
        },
      };
    },
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
  };

  useEffect(() => {
    getListVideo();
    getListKategoriPengetahuan();
    getPaketSoal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    if (mode === 'edit' && typeof youtubeVideoSelected === 'string') {
      const videSelected = listVideo.find(
        (item) => item.videoId === youtubeVideoSelected
      );
      setManajemenPengetahuanState('youtubeVideoSelected', {
        label: videSelected?.title,
        value: videSelected?.videoId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  useEffect(() => {
    const fetchPelatihanRelevan = async () => {
      if (!kategoriKlinikKhusus) return;
      if (kategoriKlinikKhusus?.value === 'UTAMA') {
        setManajemenPengetahuanState('review_url', '');
        await getPelatihanRelevan();
        await getListTipeMandiri();
      } else {
        await getPengetahuanUtama();
      }
    };

    fetchPelatihanRelevan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kategoriKlinikKhusus]);

  useEffect(() => {
    if (is_klinik_khusus === true && type === 'asynchronized') {
      setManajemenPengetahuanState('is_klinik_khusus', false);
      toast({
        title: 'Klinik Khusus hanya tersedia untuk Pengetahuan Synchronized',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_klinik_khusus]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (kategoriKlinikKhusus?.value === 'UTAMA') {
        getPelatihanRelevan(search_pelatihan);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search_pelatihan]);

  return (
    <SidebarWithHeader spacing={false}>
      <Box
        p={4}
        bg="#EDF2F7"
        boxShadow="0px 10px 15px -3px rgba(15, 23, 42, 0.08)"
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Flex justifyContent="center" alignItems="center">
            {mode !== '' && (
              <IconButton
                aria-label="Previous Page"
                icon={<AiOutlineArrowLeft />}
                fontSize="md"
                mr={2}
                onClick={() => setManajemenPengetahuanState('mode', '')}
              />
            )}
            <Heading
              as="h2"
              fontSize="md"
              fontWeight="bold"
              lineHeight="normal"
            >
              {mode === 'create' ? 'Tambah' : mode === 'edit' ? 'Ubah' : ''}{' '}
              Pengetahuan
            </Heading>
          </Flex>
          {!canMutate ? null : (mode === 'create' || mode === 'edit') &&
            publish ? (
            <Button
              colorScheme="green"
              rightIcon={<AiFillPlusCircle color="white" size={16} />}
              isLoading={loadingAction}
              spinnerPlacement="start"
              loadingText="Publish"
              onClick={() => postData()}
            >
              Publish
            </Button>
          ) : (mode === 'create' || mode === 'edit') && !publish ? (
            <Button
              color="white"
              bg="#3C4952"
              _hover={{ bg: '#3C4952' }}
              rightIcon={<AiFillPlusCircle color="white" size={16} />}
              isLoading={loadingAction}
              spinnerPlacement="start"
              loadingText="Simpan Draft"
              onClick={() => postData()}
            >
              Simpan Draft
            </Button>
          ) : (
            <Button
              colorScheme="green"
              rightIcon={<AiFillPlusCircle color="white" size={16} />}
              onClick={() => {
                clearState();
                setManajemenPengetahuanState('mode', 'create');
              }}
            >
              Tambah Baru
            </Button>
          )}
        </Flex>
      </Box>
      {mode === '' && (
        <Box px={4} py={3} bg="white" borderBottom="1px solid #E2E8F0">
          <HStack spacing={3} flexWrap="wrap">
            <InputGroup size="sm" maxW="280px">
              <InputLeftAddon bg="white" children={<FiSearch size={14} />} />
              <Input
                placeholder="Cari pengetahuan..."
                bg="white"
                value={filterKeyword}
                onChange={(e) => searchPengetahuan(e.target.value)}
              />
            </InputGroup>
            <Box minW="160px">
              <Select
                placeholder="Status"
                options={statusOptions}
                value={statusOptions.find((o) => o.value === filterStatusPublish) ?? null}
                onChange={(val: any) => filterByStatus(val ? val.value : '0,1')}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, minHeight: '32px', fontSize: '14px' }),
                }}
              />
            </Box>
            <Box minW="190px">
              <Select
                placeholder="Jenis"
                options={jenisOptions}
                value={jenisOptions.find((o) => o.value === filterJenisPengetahuan) ?? null}
                onChange={(val: any) => filterByJenis(val ? val.value : '')}
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, minHeight: '32px', fontSize: '14px' }),
                }}
              />
            </Box>
            <Box minW="200px">
              <Select
                placeholder="Kategori"
                options={listKategoriPengetahuan}
                value={listKategoriPengetahuan.find((o) => String(o.value) === filterKategoriId) ?? null}
                onChange={(val: any) => filterByKategori(val ? String(val.value) : '')}
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, minHeight: '32px', fontSize: '14px' }),
                }}
              />
            </Box>
            {hasActiveFilter && (
              <Button size="sm" variant="ghost" colorScheme="red" onClick={() => clearFilter()}>
                Reset Filter
              </Button>
            )}
          </HStack>
        </Box>
      )}
      {mode === 'create' || mode === 'edit' ? (
        <Grid
          templateColumns="repeat(6, 1fr)"
          py={8}
          gap={4}
          px={4}
          boxShadow="lg"
          bg="white"
        >
          {/* judul */}
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Judul
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <Input
              onChange={(e) =>
                setManajemenPengetahuanState('title', e.target.value)
              }
              fontSize="sm"
              value={title}
              bg="#F6F5F8"
              _focus={{
                ring: '1',
                ringColor: 'green',
                borderColor: 'green',
              }}
            />
          </GridItem>

          {/* Sync/Async */}
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Jenis Pengetahuan
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <RadioGroup
              defaultValue={type}
              onChange={(e) => setManajemenPengetahuanState('type', e)}
            >
              <Stack spacing={5} direction="row">
                <Radio colorScheme="green" value="synchronized">
                  Synchronized
                </Radio>
                <Radio colorScheme="green" value="asynchronized">
                  Asynchronized
                </Radio>
              </Stack>
            </RadioGroup>
          </GridItem>

          {type === 'synchronized' && (
            <>
              {/* Jadwal Pengetahuan */}
              <GridItem colSpan={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  Jadwal Pengetahuan
                </Text>
              </GridItem>
              <GridItem colSpan={2} display="flex">
                <Input
                  defaultValue={startDate}
                  type="datetime-local"
                  onChange={(e) =>
                    setManajemenPengetahuanState('startDate', e.target.value)
                  }
                  bg="#F6F5F8"
                  // w="30%"
                  _focus={{
                    ring: '1',
                    ringColor: 'green',
                    borderColor: 'green',
                  }}
                />
              </GridItem>
              <GridItem
                colSpan={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Text fontWeight="semibold" fontSize="sm">
                  SD
                </Text>
              </GridItem>
              <GridItem colSpan={2} display="flex">
                <Input
                  defaultValue={endDate}
                  type="datetime-local"
                  onChange={(e) =>
                    setManajemenPengetahuanState('endDate', e.target.value)
                  }
                  bg="#F6F5F8"
                  _focus={{
                    ring: '1',
                    ringColor: 'green',
                    borderColor: 'green',
                  }}
                />
              </GridItem>
              {/* Jam Pelajaran */}
              <GridItem colSpan={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  Jam Pelajaran
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <Input
                  onChange={(e) =>
                    setManajemenPengetahuanState('jam_pelajaran', e.target.value)
                  }
                  fontSize="sm"
                  value={state.jam_pelajaran || ''}
                  bg="#F6F5F8"
                  placeholder="Masukkan jam pelajaran"
                  _focus={{
                    ring: '1',
                    ringColor: 'green',
                    borderColor: 'green',
                  }}
                />
              </GridItem>
            </>
          )}

          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Penyelenggara
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <Input
              onChange={(e) =>
                setManajemenPengetahuanState('organizer', e.target.value)
              }
              fontSize="sm"
              value={organizer}
              bg="#F6F5F8"
              _focus={{
                ring: '1',
                ringColor: 'green',
                borderColor: 'green',
              }}
            />
          </GridItem>
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Pilih Kategori
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <Select
              placeholder="Pilih Kategori"
              options={listKategoriPengetahuan}
              isClearable
              onChange={(e) =>
                setManajemenPengetahuanState('kategoriPengetahuanId', e)
              }
              value={kategoriPengetahuanId}
              styles={colourStyles}
            />
          </GridItem>

          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Klinik Khusus
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <RadioGroup
              value={String(is_klinik_khusus)}
              onChange={(e) => {
                const isKlinikKhusus = e === 'true';
                setManajemenPengetahuanState('is_klinik_khusus', isKlinikKhusus);

                if (!isKlinikKhusus) {
                  setManajemenPengetahuanState('kategoriKlinikKhusus', null);
                  setManajemenPengetahuanState('pengetahuanUtamaSelected', null);
                  setManajemenPengetahuanState('jenisPersyaratan', '');
                  setManajemenPengetahuanState('pelatihanSelected', []);
                  setManajemenPengetahuanState('pelatihanPrasyaratSelected', []);
                  setManajemenPengetahuanState('tipe_klinik_khusus_mandiri', null);
                  setManajemenPengetahuanState(
                    'prasyarat_klinik_khusus_mandiri',
                    []
                  );
                  setManajemenPengetahuanState('listPrasyaratMandiri', []);
                }
              }}
            >
              <Stack spacing={5} direction="row">
                <Radio colorScheme="green" value="true">
                  Ya
                </Radio>
                <Radio colorScheme="green" value="false">
                  Tidak
                </Radio>
              </Stack>
            </RadioGroup>
          </GridItem>

          {is_klinik_khusus && (
            <>
              <GridItem colSpan={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  Kategori Klinik Khusus
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <Select<{ label: string; value: string }, false>
                  placeholder="Pilih Kategori"
                  options={listKategoriKlinikKhusus}
                  isClearable
                  onChange={(e) => {
                    setManajemenPengetahuanState('kategoriKlinikKhusus', e);
                    const selectedKategori = e?.value ?? '';

                    if (selectedKategori !== 'UTAMA') {
                      setManajemenPengetahuanState('jenisPersyaratan', '');
                      setManajemenPengetahuanState('pelatihanSelected', []);
                      setManajemenPengetahuanState(
                        'pelatihanPrasyaratSelected',
                        []
                      );
                      setManajemenPengetahuanState(
                        'tipe_klinik_khusus_mandiri',
                        null
                      );
                      setManajemenPengetahuanState(
                        'prasyarat_klinik_khusus_mandiri',
                        []
                      );
                      setManajemenPengetahuanState('listPrasyaratMandiri', []);
                    }
                  }}
                  value={kategoriKlinikKhusus}
                  styles={colourStyles}
                />
              </GridItem>

              {kategoriKlinikKhusus?.value === 'SUB' && (
                <>
                  <GridItem colSpan={1}></GridItem>
                  <GridItem colSpan={5}>
                    <Select
                      options={listPengetahuanUtama}
                      onChange={(e) => {
                        setManajemenPengetahuanState(
                          'pengetahuanUtamaSelected',
                          e
                        );
                      }}
                      value={pengetahuanUtamaSelected}
                      placeholder="Pilih Tema Utama"
                    />
                  </GridItem>
                </>
              )}
            </>
          )}

          {/* Jenis Persyaratan — hanya untuk Synchronized + Klinik Khusus + Tema Utama */}
          {type === 'synchronized' && is_klinik_khusus && kategoriKlinikKhusus?.value === 'UTAMA' && (
            <>
              <GridItem colSpan={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  Jenis Persyaratan
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <RadioGroup
                  value={jenisPersyaratan}
                  onChange={(e) => {
                    setManajemenPengetahuanState('jenisPersyaratan', e);
                    setManajemenPengetahuanState('pelatihanSelected', []);
                    setManajemenPengetahuanState('pelatihanPrasyaratSelected', []);
                    setManajemenPengetahuanState('tipe_klinik_khusus_mandiri', null);
                    setManajemenPengetahuanState('prasyarat_klinik_khusus_mandiri', []);
                    setManajemenPengetahuanState('listPrasyaratMandiri', []);
                  }}
                >
                  <Stack spacing={5} direction="row">
                    <Radio colorScheme="green" value="pendalaman_pelatihan">
                      Pendalaman Pelatihan
                    </Radio>
                    <Radio colorScheme="green" value="mandiri">
                      Mandiri
                    </Radio>
                  </Stack>
                </RadioGroup>
              </GridItem>

              {jenisPersyaratan === 'pendalaman_pelatihan' && (
                <>
                  <GridItem colSpan={1} />
                  <GridItem colSpan={5}>
                    <Select
                      options={listPelatihan}
                      onChange={(e) => {
                        setManajemenPengetahuanState('pelatihanSelected', e);
                        setManajemenPengetahuanState(
                          'pelatihanPrasyaratSelected',
                          e ?? []
                        );
                      }}
                      onInputChange={(inputValue) => {
                        setManajemenPengetahuanState('search_pelatihan', inputValue);
                      }}
                      value={pelatihanSelected}
                      isMulti={true}
                      placeholder="Pilih Pelatihan Relevan"
                    />
                  </GridItem>
                </>
              )}
            </>
          )}

          {type === 'synchronized' && is_klinik_khusus && kategoriKlinikKhusus?.value === 'UTAMA' && jenisPersyaratan === 'mandiri' && (
            <>
              <GridItem colSpan={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  Tipe Prasyarat
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <Select
                  placeholder="Pilih Tipe Prasyarat"
                  options={listTipeMandiri}
                  isClearable
                  onChange={(e: any) => {
                    setManajemenPengetahuanState('tipe_klinik_khusus_mandiri', e);
                    setManajemenPengetahuanState('prasyarat_klinik_khusus_mandiri', []);
                    if (e?.value) getListPrasyaratMandiri(e.value);
                  }}
                  value={tipe_klinik_khusus_mandiri}
                  styles={colourStyles}
                />
              </GridItem>

              {tipe_klinik_khusus_mandiri && (
                <>
                  <GridItem colSpan={1} />
                  <GridItem colSpan={5}>
                    <Select
                      placeholder="Pilih Prasyarat"
                      options={listPrasyaratMandiri}
                      isMulti
                      onChange={(e) =>
                        setManajemenPengetahuanState(
                          'prasyarat_klinik_khusus_mandiri',
                          e
                        )
                      }
                      value={prasyarat_klinik_khusus_mandiri}
                      styles={colourStyles}
                    />
                  </GridItem>
                </>
              )}
            </>
          )}

          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Cover Thumbnail
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <BoxUploadFile
              setFile={setManajemenPengetahuanState}
              typeFile="image"
              defaultFile={image}
            />
          </GridItem>

          {/* Informasi Umum */}
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Informasi Umum
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <EditorComponent
              description={description}
              setDescription={setManajemenPengetahuanState}
            />
          </GridItem>

          {/* Kuisioner */}
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              kuesioner
            </Text>
          </GridItem>
          <GridItem colSpan={5}>
            <Input
              placeholder="Masukan Link Kuesioner"
              onChange={(e) =>
                setManajemenPengetahuanState('review_url', e.target.value)
              }
              fontSize="sm"
              value={review_url}
              isDisabled={
                is_klinik_khusus && kategoriKlinikKhusus?.value === 'UTAMA'
              }
              bg="#F6F5F8"
              _focus={{
                ring: '1',
                ringColor: 'green',
                borderColor: 'green',
              }}
            />
          </GridItem>

          {/* Divider */}
          <GridItem colSpan={6}>
            <Box borderBottom="1px solid #E2E8F0" my={2} />
          </GridItem>

          {/* Custom Sertifikat */}
          <GridItem colSpan={6}>
            <Text fontWeight="semibold" fontSize="sm" mb={4}>
              Custom Sertifikat
            </Text>
            <Grid templateColumns="repeat(6, 1fr)" gap={4}>
              <GridItem colSpan={1}>
                <Text fontWeight="medium" fontSize="sm">
                  File Design Sertifikat
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <BoxUploadFile
                  setFile={setManajemenPengetahuanState}
                  typeFile="image"
                  defaultFile={customSertifikat}
                  nameFile="customSertifikat"
                  uniqueId="certificate"
                />
              </GridItem>

              <GridItem colSpan={1}>
                <Text fontWeight="medium" fontSize="sm">
                  Keterangan Tambahan
                </Text>
              </GridItem>
              <GridItem colSpan={5}>
                <Textarea
                  placeholder="Masukkan keterangan tambahan untuk sertifikat"
                  onChange={(e) =>
                    setManajemenPengetahuanState(
                      'keteranganSertifikat',
                      e.target.value
                    )
                  }
                  fontSize="sm"
                  value={keteranganSertifikat}
                  rows={4}
                />
              </GridItem>
            </Grid>
          </GridItem>

          {/* Divider */}
          <GridItem colSpan={6}>
            <Box borderBottom="1px solid #E2E8F0" my={2} />
          </GridItem>

          {/* Publikasi */}
          <GridItem colSpan={1}>
            <Text fontWeight="semibold" fontSize="sm">
              Publikasi
            </Text>
          </GridItem>
          <GridItem colSpan={5} display="flex">
            <Switch
              defaultChecked={publish}
              colorScheme="green"
              mr={2}
              onChange={(e) =>
                setManajemenPengetahuanState('publish', e.target.checked)
              }
            />
            <Text fontWeight="semibold" fontSize="sm">
              {publish ? 'Publikasi' : 'Draft'}
            </Text>
          </GridItem>
        </Grid>
      ) : (
        <Grid templateColumns="repeat(3, 1fr)" gap={4} m={4}>
          {loadingData ? (
            <>
              <Skeleton height="170px" width="100%" />
              <Skeleton height="170px" width="100%" />
              <Skeleton height="170px" width="100%" />
            </>
          ) : loadingEdit ? (
            <Spinner />
          ) : (
            <>
              {listData.map((item) => (
                <GridItem colSpan={{ base: 3, md: 1 }} key={item.id}>
                  <CardItem item={item} image={item.thumbnail} />
                </GridItem>
              ))}
            </>
          )}
        </Grid>
      )}
      {mode === '' && pagination && totalPage > 1 && (
        <Flex justifyContent="end" mt={2} pb={4} mr={3}>
          <Pagination
            handleChange={handlePageChange}
            totalPage={totalPage}
            page={page}
          />
        </Flex>
      )}
    </SidebarWithHeader>
  );
};

const ManajemenPengetahuanMain: React.FC = () => {
  return (
    <ManajemenPengetahuanController.Provider>
      <YoutubeContext.Provider>
        <KelolaKontenManajemenPelatihanController.Provider>
          <ManajemenPengetahuan />
        </KelolaKontenManajemenPelatihanController.Provider>
      </YoutubeContext.Provider>
    </ManajemenPengetahuanController.Provider>
  );
};

export default ManajemenPengetahuanMain;
